// A login lifetime, not an access-token lifetime. A -> B -> A must invalidate A's old work.
export interface AccountSession {
  readonly userId: string | null;
  readonly generation: number;
}

let current: AccountSession = { userId: null, generation: 0 };
const listeners = new Set<() => void>();

export const getAccountSession = () => current;
export const isCurrentAccountSession = (session: AccountSession) => (
  session.generation === current.generation && session.userId === current.userId
);

export function setAccountSession(userId: string | null): AccountSession {
  if (current.userId !== userId) {
    if (current.userId !== null) {
      try {
        for (let index = sessionStorage.length - 1; index >= 0; index--) {
          const key = sessionStorage.key(index);
          if (key?.startsWith('billing-acceptance-v1:')) sessionStorage.removeItem(key);
        }
      } catch { /* Storage can be disabled; account identity still invalidates work. */ }
    }
    current = { userId, generation: current.generation + 1 };
    listeners.forEach((listener) => listener());
  }
  return current;
}

export function subscribeAccountSession(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function assertCurrentAccountSession(session: AccountSession): void {
  if (!isCurrentAccountSession(session)) {
    throw new Error('Account changed; this browser operation has stopped.');
  }
}
